"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HeaderItem = void 0;

var _jsxRuntime = require("react/jsx-runtime");

var classes = {
  "root": "header-item-module__root___3Aocy"
};

var HeaderItem = function HeaderItem(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
    className: classes.root,
    children: children
  });
};

exports.HeaderItem = HeaderItem;